// src/components/SpinnerProgress.js
import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const SpinnerProgress = ({ progress }) => {
  return (
    <div style={{ width: 120, height: 120, margin: '0 auto' }}>
      <CircularProgressbar
        value={progress}
        text={`${progress}%`}
        styles={buildStyles({
          // Smooth transition for the path
          pathTransitionDuration: 0.5,
          // Customize text size and colors as needed
          textSize: '16px',
          pathColor: `rgba(62, 152, 199, ${progress / 100})`,
          textColor: '#3e98c7',
          trailColor: '#d6d6d6',
        })}
      />
    </div>
  );
};

export default SpinnerProgress;
